// src/features/system/edge-tasks/api/edgeMetricsApi.ts
import { bff } from '@/lib/http/bff';
import { dispatchEdgeTask } from './edgeTasksApi';

// ── Types matching BFF digester output ──────────────────────────────────

export interface DiskSnapshot {
  mount: string;
  usagePercent: number | null;
  totalGb: number | null;
  freeGb: number | null;
}

export interface NetworkSnapshot {
  name: string;
  bytesSent: number;
  bytesReceived: number;
  speedBps: number;
}

export interface EdgeMetricsSnapshot {
  ts: string;
  agentId: string;
  cpu: number | null;
  cpuCores: number | null;
  cpuArch: string;
  memoryPercent: number | null;
  memoryUsedMb: number | null;
  memoryTotalMb: number | null;
  hostname: string;
  uptimeMs: number | null;
  disks: DiskSnapshot[];
  network: NetworkSnapshot[];
}

export interface EdgeMetricsResponse {
  snapshots: EdgeMetricsSnapshot[];
  latest: EdgeMetricsSnapshot | null;
}

// ── Queries ─────────────────────────────────────────────────────────────

export interface EdgeMetricsQuery {
  scope_key?: string;
  from?: string;
  to?: string;
  limit?: number;
}

export const fetchEdgeMetrics = (q: EdgeMetricsQuery = {}): Promise<EdgeMetricsResponse> =>
  bff.get<EdgeMetricsResponse>('/orchestrator/hot-stream/edge-metrics', { ...q });

// ── Dispatch "collect now" ──────────────────────────────────────────────

export const requestSystemMetrics = (agentId?: string, sampleMs = 2000) =>
  dispatchEdgeTask({
    workflow_key: 'edge.system_metrics',
    ...(agentId ? { agent_id: agentId } : {}),
    inputs: { sample_ms: sampleMs },
  });
